module.exports = __webpack_public_path__ + "img/1525939323.0fc1009e.jpg";